import React, { useRef } from "react";
import "./AddRecordBatchStep1.css"; // Create this CSS file

interface AddRecordBatchStep1Props {
  onFileChange: (files: FileList | null) => void;
}

const AddRecordBatchStep1: React.FC<AddRecordBatchStep1Props> = ({
  onFileChange,
}) => {
  const dropRef = useRef<HTMLDivElement>(null);

  const handleDragOver = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    if (dropRef.current) {
      dropRef.current.classList.add("drag-over");
    }
  };

  const handleDragLeave = (e: React.DragEvent<HTMLDivElement>) => {
    if (dropRef.current) {
      dropRef.current.classList.remove("drag-over");
    }
  };

  const handleDrop = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    if (dropRef.current) {
      dropRef.current.classList.remove("drag-over");
    }

    if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
      onFileChange(e.dataTransfer.files);
    }
  };

  return (
    <div
      className="drop-area step-area"
      ref={dropRef}
      onDragOver={handleDragOver}
      onDragLeave={handleDragLeave}
      onDrop={handleDrop}
    >
      <input
        type="file"
        id="fileInput"
        onChange={(e) => onFileChange(e.target.files)}
        hidden
      />
      <label htmlFor="fileInput" className="drop-area-label">
        Drag and drop files here, or click to select files.
      </label>
    </div>
  );
};

export default AddRecordBatchStep1;
